var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiologia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-biologia-1{fill:#464af0;}.subject-biologia-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Biologia") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4080",
    "data-name": "Group 4080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3410",
    "data-name": "Path 3410"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M38,35.92a.75.75,0,0,1-.7-.49c0-.1-3.61-9.53-11.73-9.53H25c-9.62.5-13.71-10.38-13.75-10.49a.75.75,0,1,1,1.4-.51c0,.1,3.77,9.93,12.27,9.51,9.61-.5,13.71,10.38,13.75,10.49a.74.74,0,0,1-.44,1A.75.75,0,0,1,38,35.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_3411",
    "data-name": "Path 3411"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M27.16,42.18a.77.77,0,0,1-.58-.26c-.07-.09-7.44-9.08-2.21-17.16,4.63-7.14-2-15.3-2.1-15.38a.76.76,0,0,1,.1-1.06.75.75,0,0,1,1.05.1c.07.09,7.44,9.08,2.21,17.15-4.63,7.15,2,15.31,2.1,15.39a.75.75,0,0,1-.1,1A.72.72,0,0,1,27.16,42.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4075",
    "data-name": "Group 4075"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_20",
    "data-name": "Line 20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M20.19,24.71A.38.38,0,0,1,20,24l6.35-3.67a.37.37,0,1,1,.37.65l-6.34,3.67A.41.41,0,0,1,20.19,24.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_21",
    "data-name": "Line 21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M17.43,23a.37.37,0,0,1-.32-.19.37.37,0,0,1,.14-.51l9-5.2a.37.37,0,0,1,.51.14.36.36,0,0,1-.13.51l-9,5.2A.41.41,0,0,1,17.43,23Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_22",
    "data-name": "Line 22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M15.3,20.92a.36.36,0,0,1-.32-.18.38.38,0,0,1,.13-.52l10.44-6a.37.37,0,1,1,.37.65l-10.43,6A.34.34,0,0,1,15.3,20.92Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_23",
    "data-name": "Line 23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M13.55,18.63a.37.37,0,0,1-.32-.19.37.37,0,0,1,.13-.51l11.19-6.46a.37.37,0,0,1,.37.65L13.74,18.58A.45.45,0,0,1,13.55,18.63Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4076",
    "data-name": "Group 4076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_24",
    "data-name": "Line 24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M23.32,30.12a.35.35,0,0,1-.32-.18.36.36,0,0,1,.13-.51l6.35-3.67a.38.38,0,0,1,.51.14.37.37,0,0,1-.14.51l-6.34,3.66A.34.34,0,0,1,23.32,30.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_25",
    "data-name": "Line 25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M23.42,33.37a.38.38,0,0,1-.19-.7l9-5.19a.37.37,0,1,1,.37.64l-9,5.2A.41.41,0,0,1,23.42,33.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_26",
    "data-name": "Line 26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M24.15,36.25a.38.38,0,0,1-.19-.7l10.44-6a.37.37,0,0,1,.51.14.38.38,0,0,1-.14.51l-10.43,6A.34.34,0,0,1,24.15,36.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_27",
    "data-name": "Line 27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "subject-biologia-2",
    d: "M25.26,38.91a.37.37,0,0,1-.19-.69l11.19-6.46a.37.37,0,0,1,.51.13.39.39,0,0,1-.14.52L25.45,38.86A.34.34,0,0,1,25.26,38.91Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiologia);
export default __webpack_public_path__ + "static/media/biologia.5e53d0cb64a0af875c146a62c516d6e6.svg";
export { ForwardRef as ReactComponent };